<div class="main-container">
    <div class="filter-container">
        <h2 style="align-items: flex-end;">
            <div
                style="background-color: var(--primary-500); display: flex; border-radius: 7px; width: 27px; height: 30px;">
                <img [src]="mainIcon" alt="mainIcon" style="filter: brightness(0) invert(1); object-fit: cover;">
            </div>
            Data Scraping
        </h2>
        <p>ID</p>
        <input [(ngModel)]="filterID" type="text" pInputText placeholder="Enter ID">
        <p>Data Source</p>
        <p-dropdown [(ngModel)]="filterDataSource" [options]="filterDataSourceOption" placeholder="Select Data Source"
            [style]="{'width': '100%'}"></p-dropdown>
        <p>Start Date</p>
        <p-calendar [(ngModel)]="filterStartDate" [maxDate]="todayDate" [showIcon]="true" appendTo="body"
            placeholder="Enter Date" dateFormat="dd/mm/yy"></p-calendar>
        <p>End Date</p>
        <p-calendar [(ngModel)]="filterEndDate" [maxDate]="todayDate" [showIcon]="true" appendTo="body"
            placeholder="Enter Date" dateFormat="dd/mm/yy"></p-calendar>
        <p>Status</p>
        <p-dropdown [(ngModel)]="filterStatus" [options]="filterStatusOption" placeholder="Select Status"
            [style]="{'width': '100%'}"></p-dropdown>
        <div class="button-container">
            <p-button label="Clear" (onClick)="onClearClick()" [outlined]="true" styleClass="clearBtn"></p-button>
            <p-button label="Apply" (onClick)="onApplyClick()"></p-button>
        </div>
    </div>
    <div class="result-container">
        <div class="top-section">
            <p>ผลลัพธ์ {{ requestList.length }} รายการ</p>
            <p-button label="Create Data Scraping Request" (onClick)="onCreateClick()" icon="pi createIcon"></p-button>
        </div>
        <p-treeTable [value]="treeNode" [resizableColumns]="true" selectionMode="checkbox"
            [(selection)]="selectedTreeNode">
            <ng-template pTemplate="header">
                <tr [ngStyle]="{}">
                    <th [ngStyle]="{'width': '20%', 'border-top-left-radius': '20px', 'border-bottom-left-radius': '20px'}"
                        ttSortableColumn="ScrapingScript">
                        Script <p-treeTableSortIcon field="ScrapingScript"></p-treeTableSortIcon>
                    </th>
                    <th [ngStyle]="{'width': '12%'}" [ttSortableColumn]="'Date'">
                        Date 
                        <p-treeTableSortIcon [field]="'Date'"></p-treeTableSortIcon>
                    </th>
                    <th [ngStyle]="{'width': '20%'}">
                        Information
                    </th>
                    <th [ngStyle]="{'width': '13%'}" [ttSortableColumn]="'FoundQty'">
                        FoundQty 
                        <p-treeTableSortIcon
                            [field]="'FoundQty'">
                        </p-treeTableSortIcon>
                    </th>
                    <th [ngStyle]="{'width': '13%'}" [ttSortableColumn]="'SavedQty'">
                        SavedQty 
                        <p-treeTableSortIcon
                            [field]="'SavedQty'">
                        </p-treeTableSortIcon>
                    </th>
                    <th [ngStyle]="{'width': '13%'}" [ttSortableColumn]="'UpdatedQty'">
                        UpdatedQty 
                        <p-treeTableSortIcon
                            [field]="'UpdatedQty'">
                        </p-treeTableSortIcon>
                    </th>
                    <th [ngStyle]="{'width': '20%'}" [ttSortableColumn]="'Status'">
                        Status 
                        <p-treeTableSortIcon
                            [field]="'Status'"></p-treeTableSortIcon></th>
                    <th
                        [ngStyle]="{'width': '15%', 'border-top-right-radius': '20px', 'border-bottom-right-radius': '20px'}">
                        Action</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
                <tr [ttRow]="rowNode" [ttSelectableRow]="rowNode" [ngClass]="{'request': rowData.hasChildren}">
                    <td>
                        <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
                        {{ rowData.AttemptID ? rowData.AttemptID : rowData.ScrapingScript }}
                    </td>
                    <td>{{ (+rowData.Date)  * 1000 | date: 'dd/MM/yyyy' }}</td>
                    <td>
                        <div *ngIf="rowData.ScrapingInformation">
                            <p *ngIf="rowData.ScrapingInformation.Information">{{
                                rowData.ScrapingInformation.Information }}</p>
                            <p *ngIf="rowData.ScrapingInformation.Description">{{
                                rowData.ScrapingInformation.Description }}</p>
                            <p *ngIf="rowData.ScrapingInformation.ScrapingName">{{
                                rowData.ScrapingInformation.ScrapingName }}</p>

                            <p *ngIf="rowData.ScrapingInformation.GrantType">GrantType: {{
                                rowData.ScrapingInformation.GrantType }}</p>
                            <p *ngIf="rowData.ScrapingInformation.StartPage || rowData.ScrapingInformation.StopPage">
                                จากหน้า: {{ rowData.ScrapingInformation.StartPage }}</p>
                            <p *ngIf="rowData.ScrapingInformation.StopPage">ถึงหน้า: {{
                                rowData.ScrapingInformation.StopPage }}</p>
                            <p *ngIf="rowData.ScrapingInformation.NewsCountNum">จำนวนข่าวต่อรอบ: {{
                                rowData.ScrapingInformation.NewsCountNum }}</p>
                            <p *ngIf="rowData.ScrapingInformation.AccessToken">AccessToken: {{
                                rowData.ScrapingInformation.AccessToken | slice:0:6 }}...</p>
                            <p *ngIf="rowData.ScrapingInformation.Username">Username: {{
                                rowData.ScrapingInformation.Username }}</p>
                            
                        </div>
                    </td>
                    <td>{{ rowData.FoundQty }}</td>
                    <td>{{ rowData.SavedQty }}</td>
                    <td>{{ rowData.UpdatedQty }}</td>
                    <td>
                        <div class="status-container">
                            <div
                                [ngClass]="[
                                    rowData.isFailed ? 'failed' : '',
                                    getStatusClass(rowData.Status),
                                    'status',
                                    rowData.hasChildren ? 'request' : ''
                                ]">
                                {{ filterStatusOption[rowData.Status + 1] }}
                            </div>
                        </div>
                    </td>
                    <td>
                        <div class="button-container">
                            <!-- <p-button *ngIf="!rowData.hasChildren" (onClick)="onViewClick(rowData)" [rounded]="true" [text]="true" icon="pi viewIcon" [disabled]="rowData.Status < 4" pTooltip="View Analysis" tooltipPosition="top"></p-button> -->
                            <button class="checkBtn" *ngIf="rowData.hasChildren"
                                [ngClass]="{'loadingBtn': rowData.Status % 2 == 1, 'complete': rowData.Status >= filterStatusOption.length - 2}"
                                (click)="onCheckClick(rowData)" class="checkBtn">
                                <img [ngClass]="{'loading': rowData.Status % 2 == 1}"
                                    [src]="returnCheckIcon(rowData.Status)" alt="check"
                                    pTooltip="{{ getPopupText(rowData.Status) }}" tooltipPosition="top">
                            </button>
                            <p-button *ngIf="rowData.hasChildren && rowData.ScrapingType != 'File'"
                                (onClick)="onRestartClick(rowData)" icon="pi restartIcon"
                                [disabled]="rowData.Status % 2 == 1" pTooltip="Restart"
                                tooltipPosition="top"></p-button>
                            <p-button (onClick)="onDeleteClick(rowData)" icon="pi deleteIcon" severity="danger"
                                pTooltip="Delete" tooltipPosition="top"></p-button>
                        </div>
                    </td>
                </tr>
            </ng-template>


        </p-treeTable>
        <div class="bottom-section">
            <p-dropdown [(ngModel)]="pageSize" [options]="pageSizeList"
                (onChange)="onPageSizeChange($event)"></p-dropdown>
            <p>{{ getRequestBegin() + 1 }} ถึง {{ getRequestEnd() }} จาก {{ totalPage }} รายการ</p>
            <div class="button-container">
                <button (click)="onToBeginningClick()"><img [src]="toBeginningIcon" alt="beginning"></button>
                <button (click)="onBackClick()"><img [src]="backIcon" alt="back"></button>
                <button class="pageBtn" *ngFor="let i of [4, 3, 2, 1]" (click)="goto(currentPage - i)"
                    [ngClass]="{'hidden': !isActiveButton(currentPage - i)}">{{ currentPage - i }}</button>
                <button (click)="onPageNumberClick()" class="currentBtn">{{ currentPage }}</button>
                <button class="pageBtn" *ngFor="let i of [1, 2, 3, 4]" (click)="goto(currentPage + i)"
                    [ngClass]="{'hidden': !isActiveButton(currentPage + i)}">{{ currentPage + i }}</button>
                <button (click)="onNextClick()"><img [src]="nextIcon" alt="next"></button>
                <button (click)="onToLastClick()"><img [src]="toLastIcon" alt="last"></button>
            </div>
            <p-dialog [style]="{'width': 'fit-content', 'height': 'fit-contenet'}" [(visible)]="goto_dialog_visible"
                [modal]="true" [draggable]="false" [resizable]="false">
                <div class="dialog-container">
                    Goto: <p-dropdown [(ngModel)]="gotoPage" [options]="getGotoOptions()" appendTo="body"></p-dropdown>
                    <button (click)="onGotoClick()">Go</button>
                </div>
            </p-dialog>
        </div>
    </div>
    <p-toast></p-toast>
    <p-confirmDialog #cd [style]="{width: '50vw'}">
        <ng-template pTemplate="header">
            <h3>Confirmation</h3>
        </ng-template>
        <ng-template pTemplate="footer">
            <button type="button" pButton icon="pi pi-times" label="No" (click)="cd.reject()"></button>
            <button type="button" pButton icon="pi pi-check" label="Yes" (click)="cd.accept()"></button>
        </ng-template>
    </p-confirmDialog>
    <p-dialog [style]="{'width': '50vw'}" [(visible)]="dialog_visible" [modal]="true" [draggable]="false"
        [resizable]="false" [closable]="false">
        <div class="dialog-container">
            <h2>Create Data Scraping Request</h2>
            <p>Scraping Type</p>
            <p-dropdown [formControl]="scrapingTypeSelected" placeholder="Select Scraping type" appendTo="body"
                [options]="scrapingTypes" [style]="{'width': '100%', 'margin-bottom': '20px'}"></p-dropdown>
            <div *ngIf="scrapingTypeSelected.value.length && (scrapingTypeSelected.value != scrapingTypes[2])">
                <p>Choose Data Source</p>
                <p-dropdown [formControl]="scriptSelected" [style]="{'width': '100%', 'margin-bottom': '20px'}"
                    placeholder="Choose Data Source" [options]="dataSourceList" appendTo="body">
                    <ng-template let-item pTemplate="item">
                        <div>
                            <span>{{ item.Name }} | {{ item.Description }}</span>
                        </div>
                    </ng-template>
                    <ng-template pTemplate="selectedItem">
                        <div class="flex align-items-center gap-2" *ngIf="scriptSelected">
                            <div>{{ scriptSelected.value.Name }}</div>
                        </div>
                    </ng-template>
                </p-dropdown>
            </div>
            <div *ngIf="scrapingTypeSelected.value == scrapingTypes[0] && scriptSelected.value.Parameter"
                class="formgrid grid">
                <div *ngFor="let param of scriptSelected.value.Parameter"
                    [ngClass]="'field col-' + (param.styles?.col || 12)">
                    <label>{{ param.Label ?? param.Name }}</label>


                    <p-inputNumber *ngIf="param.type === 'number'" [formControl]="getFormControl(param.Name)"
                        [min]="param.min" [max]="param.max > 0 ? param.max : null" class="w-full">
                    </p-inputNumber>

                    <input *ngIf="param.type === 'string'" type="text" [formControl]="getFormControl(param.Name)"
                        class="w-full p-inputtext">
                </div>
            </div>
            <p></p>
            <div *ngIf="scrapingTypeSelected.value == scrapingTypes[1]">
                <div *ngIf="scriptSelected.value.GrantType == 'AccessToken'">
                    <p>Access Token</p>
                    <input [(ngModel)]="accessToken" pInputText type="text" [style]="{'width': '100%'}">
                    <p></p>
                </div>
                <div *ngIf="scriptSelected.value.GrantType == 'Password'">
                    <p>Username</p>
                    <input [(ngModel)]="username" pInputText type="text" [style]="{'width': '100%'}">
                    <p>Password</p>
                    <input [(ngModel)]="password" pInputText type="text" [style]="{'width': '100%'}">
                    <P></P>
                </div>
                <div *ngFor="let param of scriptSelected.value.Parameter">
                    <div *ngIf="param.Name != 'Username' && param.Name != 'Password' && param.Name != 'AccessToken'">
                        <p>{{ param.Name }}</p>
                        <input pInputText type="text" [style]="{'width': '100%'}" [required]="param.require">
                        <P></P>
                    </div>
                </div>


                <div *ngIf="scriptSelected.value == 'Password'">
                    <p>Hastag</p>
                    {{ scriptSelected.value | json }}
                    <input [(ngModel)]="Hastag" pInputText type="text" [style]="{'width': '100%'}">
                    <P></P>
                </div>
            </div>
            <div *ngIf="scrapingTypeSelected.value == scrapingTypes[2]">
                <p>File Browser</p>
                <p></p>
                <p-fileUpload name="file[]" accept=".txt, .csv, .docx, .xls, .xlsx" (onSelect)="uploadHandler($event)"
                    [showUploadButton]="false" (onRemove)="onRemove($event)" (onClear)="onRemove($event)"
                    chooseLabel="Browse" [multiple]="false"></p-fileUpload>
                <p></p>
                <div *ngIf="uploadedFiles">
                    <p>Choose Script</p>
                    <p-dropdown [formControl]="scriptSelected" [style]="{'width': '100%', 'margin-bottom': '20px'}"
                        placeholder="Choose Scrpit" [options]="fileScriptList" appendTo="body">
                        <ng-template let-item pTemplate="item">
                            <div>
                                <span>{{ item.Name }}</span>
                            </div>
                        </ng-template>
                        <ng-template pTemplate="selectedItem">
                            <div class="flex align-items-center gap-2" *ngIf="scriptSelected.value">
                                <div>{{ scriptSelected.value.Name }}</div>
                            </div>
                        </ng-template>
                    </p-dropdown>
                    <div
                        *ngIf="scriptSelected.value && scriptSelected.value.Parameter && scriptSelected.value.Parameter.length">
                        <p>Fields</p>
                        <p></p>
                        <table>
                            <tr *ngFor="let field of scriptSelected.value.Parameter">
                                <td>{{ field.Name }}:<span *ngIf="field.require" style="color: red;">*</span> </td>
                                <td>
                                    <p-multiSelect appendTo="body" [options]="filefields"
                                        [(ngModel)]="newsFieldsVar[field.Name]" [style]="{'min-width': '20rem'}"
                                        placeholder="None"></p-multiSelect>
                                </td>
                                <td><p-button label="clear" (onClick)="newsFieldsVar[field.Name]=[]"></p-button></td>
                            </tr>
                        </table>
                    </div>
                    <p></p>
                </div>
                <p-checkbox [(ngModel)]="forceSaveSolr" [binary]="true"
                    label="Force Save Solr (Update old data)"></p-checkbox>
                <div class="button-container">
                    <p-button label="Cancel" [outlined]="true" (onClick)="onCancelClick()"
                        styleClass="cancelBtn"></p-button>
                    <p-button label="Save" (onClick)="onFileSaveClick()"></p-button>
                </div>
            </div>
            <div *ngIf="scrapingTypeSelected.value != scrapingTypes[2]">
                <p-checkbox [(ngModel)]="forceSaveSolr" [binary]="true"
                    label="Force Save Solr (Update old data)"></p-checkbox>
                <div class="button-container">
                    <p-button label="Cancel" [outlined]="true" (onClick)="onCancelClick()"
                        styleClass="cancelBtn"></p-button>
                    <p-button label="Save" (onClick)="onSaveClick()"></p-button>
                </div>
            </div>
        </div>
    </p-dialog>
</div>